import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const shoplisting = createAsyncThunk(
    "ownerDashboard",
    async (reqbody) => {
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(reqbody),
        };
        console.log("process.env==>", process.env);
        const response = await fetch(
            process.env.REACT_APP_API_URL + "api6/shoplisting",
            requestOptions
        );
        const respData = await response.json();
        console.log('async shop listing', respData.results)
        return respData;
    });
///////////////////////////////// Get days count //////////////////////////////////
export const getDays = createAsyncThunk("days-count", async (reqbody) => {
    let req_body = {};
    req_body = reqbody;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api6/autocompletedayscount", requestOptions);
    const respdata = await response.json();

    return respdata;
})





////////////////////////////////////for vat massege/////////////////////////////

export const vatcheck = createAsyncThunk("vatchecking", async (reqbody) => {
    console.log("reqbody==", reqbody)
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reqbody)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api6/vatentrycheck", requestOptions);
    const vatcheckRes = await response.json();

    return vatcheckRes;
});

const shopListSlice = createSlice({
    name: "shopLists",
    initialState: {
        shopLists: [],
        daysCount: null,
        prev_tpm: null,
        vatTpmNotCompleted: null,
        

    },
    reducers: {
        popCompleteTpmVat(state, action) {
            const popVatIndex = state.vatTpmNotCompleted.findIndex((cur) => cur === action.payload.vat_id);
            if (popVatIndex !== -1) state.vatTpmNotCompleted.splice(popVatIndex, 1);
        }
    },
    extraReducers: {
        [shoplisting.pending]: (state, action) => {
        },
        [shoplisting.rejected]: (state, action) => {
        },
        [shoplisting.fulfilled]: (state, action) => {

            if (action.payload.status === 'success') {
                state.shopLists = action.payload.results.res;
                console.log("state from success part==>", action.payload.results.res);
            }
        },
        ////////////////////for days count/////////////////////////
        [getDays.pending]: (state, action) => {

            state.loading = true;
        },
        [getDays.fulfilled]: (state, action) => {
            if (action.payload.status === "success") {
                state.loading = false;
                state.daysCount = action.payload.days_count;
                state.prev_tpm = action.payload.previous_tpm_entry;
                // state.successmsg = 'Deleted Successfully';
                state.success = true;
            }
        },
        [getDays.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        },



        //////////////////////////////////// Fetching vatcheck ///////////////////////////////
        [vatcheck.pending]: (state, action) => {

        },
        [vatcheck.fulfilled]: (state, action) => {
            state.vatTpmNotCompleted = action.payload.results.res;

        },
        [vatcheck.rejected]: (state, action) => {

        },

        



    },
});
export const { popCompleteTpmVat } = shopListSlice.actions;

export default shopListSlice.reducer;

